<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>政策配置</h1>
        <p>当前生效的是进货折扣和每级返佣比例。改比例不影响已经生成的结算单。项目推荐奖、阶梯达标奖和邀请码折扣版本还没配置。</p>
      </div>
    </div>
    <div class="ch-panel">
      <h2>每级返佣</h2>
      <table class="ch-table">
        <thead><tr><th>渠道级别</th><th>进货折扣</th><th>返佣比例</th><th>应缴保证金</th><th>生态返利</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.levelCode">
            <td>{{ row.levelName || levelName(row.levelCode) }}</td>
            <td>{{ discountText(row.purchaseDiscount) }}</td>
            <td><input v-model="row.commissionRate" style="width:120px" /></td>
            <td><input v-model="row.depositAmount" placeholder="0" style="width:120px" /></td>
            <td>
              <input v-if="row.levelCode === 'ECO'" v-model="row.rebateRate" placeholder="未配置" style="width:120px" />
              <span v-else>—</span>
            </td>
            <td><button class="ch-link" type="button" @click="save(row)">保存</button></td>
          </tr>
          <tr v-if="!list.length"><td colspan="6" class="ch-empty">还没有政策</td></tr>
        </tbody>
      </table>
      <p class="ch-note" style="margin-top:12px">比例用小数，0.05 表示 5%。应缴保证金是该级别的默认金额，单位元。渠道如果在「保证金管理」单独设过，以单独设置的为准。生态返利只填在生态伙伴这一行，空着表示还没定，充值不会自动发券。</p>
    </div>
  </div>
</template>

<script>
import { getChannelPolicies, saveChannelPolicy } from '@/api/admin'
import { discountText, levelName } from '../partner/labels'

export default {
  name: 'HqPolicies',
  data() { return { list: [] } },
  created() { this.load() },
  methods: {
    discountText, levelName,
    async load() {
      const result = await getChannelPolicies()
      this.list = result.list || []
    },
    async save(row) {
      const body = { levelCode: row.levelCode, commissionRate: row.commissionRate }
      if (row.depositAmount !== null && row.depositAmount !== undefined && String(row.depositAmount).trim() !== '') {
        body.depositAmount = row.depositAmount
      }
      if (row.levelCode === 'ECO' && row.rebateRate !== null && row.rebateRate !== undefined && String(row.rebateRate).trim() !== '') {
        body.rebateRate = row.rebateRate
      }
      await saveChannelPolicy(body)
      this.$message.success('已保存，总监审批生效')
      this.load()
    }
  }
}
</script>
